export const siteCategories = {
    "61df2458a9f3010016fd8405": {
        "label": "Digital Solutions",
        "categoryPageUrl": "/category/digital-solutions"
    },
    "61df2458a9f3010016fd8403": {
        "label": "Business Insights",
        "categoryPageUrl": "/category/business-insights"
    },
    "61df2458a9f3010016fd840c": {
        "label": "Marketing Musts",
        "categoryPageUrl": "/category/marketing-musts"
    },
    "61df2458a9f3010016fd840b": {
        "label": "Interviews & Inspo",
        "categoryPageUrl": "/category/interviews-inspo"
    },
    "61df2458a9f3010016fd8407": {
        "label": "Editor's Picks on Home Page",
        "categoryPageUrl": "/category/editor-s-pick-home-page-1"
    },
    "61df2458a9f3010016fd8408": {
        "label": "Main Featured Post",
        "categoryPageUrl": "/category/hmfp-1"
    },
    "61df2458a9f3010016fd8409": {
        "label": "Home Main Posts",
        "categoryPageUrl": "/category/home-main-posts-1"
    },
    "61df2458a9f3010016fd840a": {
        "label": "Secondary Featured Post",
        "categoryPageUrl": "/category/hsfp-1-1"
    },
    "61df2458a9f3010016fd8406": {
        "label": "Digital Solutions on Home Page",
        "categoryPageUrl": "/category/digital-solutions-home-page"
    },
    "61df2458a9f3010016fd8404": {
        "label": "Business Insights on Home Page",
        "categoryPageUrl": "/category/business-insights-home-page"
    },
    "61df2458a9f3010016fd840d": {
        "label": "Most Popular",
        "categoryPageUrl": "/category/most-popular-1-1"
    },
    "61df2458a9f3010016fd840e": {
        "label": "Must Read",
        "categoryPageUrl": "/category/must-read-1-1"
    }
}
export const categoryPath = '/explore/category/';


